/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControlRiskRead } from '../models/ControlRiskRead';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControlRiskLinksService {
    /**
     * List Control Risk Links
     * @returns ControlRiskRead Successful Response
     * @throws ApiError
     */
    public static listControlRiskLinksControlsByRiskRiskIdGet({
        riskId,
    }: {
        riskId: number,
    }): CancelablePromise<Array<ControlRiskRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/by-risk/{risk_id}',
            path: {
                'risk_id': riskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Link Control To Risk
     * @returns ControlRiskRead Successful Response
     * @throws ApiError
     */
    public static linkControlToRiskControlsControlIdRisksRiskIdPost({
        controlId,
        riskId,
        createdBy,
    }: {
        controlId: number,
        riskId: number,
        createdBy?: (string | null),
    }): CancelablePromise<ControlRiskRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/controls/{control_id}/risks/{risk_id}',
            path: {
                'control_id': controlId,
                'risk_id': riskId,
            },
            query: {
                'created_by': createdBy,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unlink Control From Risk
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unlinkControlFromRiskControlsControlIdRisksRiskIdDelete({
        controlId,
        riskId,
    }: {
        controlId: number,
        riskId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/controls/{control_id}/risks/{risk_id}',
            path: {
                'control_id': controlId,
                'risk_id': riskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Risks For Control
     * @returns ControlRiskRead Successful Response
     * @throws ApiError
     */
    public static listRisksForControlControlsControlIdRisksGet({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<Array<ControlRiskRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/{control_id}/risks',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Controls For Risk
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listControlsForRiskControlsRisksRiskIdControlsGet({
        riskId,
    }: {
        riskId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/risks/{risk_id}/controls',
            path: {
                'risk_id': riskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
